import { AbstractControl } from "@angular/forms";

export class FieldAssignmentsFormValidators {
  // requirements for field assignments
  // either target or source has to be selected -> sourceTargetValidator
  // if only target is selected (no source), a fixvalue has to be selected -> sourceOrFixValidator
  // it is not allowed to set a fixvalue and a cap -> noFixAndCapValidator

  public static sourceTargetValidator(control: AbstractControl): {[key: string]: any} | null {
    const isValid = control.get('sourceName')?.value || control.get('targetName')?.value;
    if (isValid) {
      return null;
    }
    return { sourceOrTarget: true};
  }

  public static sourceOrFixValidator(control: AbstractControl): {[key: string]: any} | null {
    const isValid = !(control.get('targetName')?.value && !control.get('fixValue')?.value && !control.get('sourceName')?.value);
    if (isValid) {
      return null;
    }
    return { sourceOrFix: true};
  }

  public static noFixAndCapValidator(control: AbstractControl): {[key: string]: any} | null {
    const isValid = !(control.get('fixValue')?.value && control.get('cap')?.value);
    if (isValid) {
      return null;
    }
    return { noFixAndCap: true};
  }
}
